// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ei-a";
export var fulfillmentFormRail = "_ei-9";
export var headerTitleRow = "_ei-c";
export var orderDetailsWrapper = "_ei-7";
export var orderLinkTrigger = "_ei-2";
export var paymentInformationGrid = "_ei-h";
export var paymentSummaryColumn = "_ei-i";
export var shipmentContainer = "_ei-b";
export var shipmentDetailsMainPane = "_ei-8";
export var shipmentNavigationCard = "_ei-5";
export var shipmentNavigationRail = "_ei-3";
export var shipmentNavigationRailHeader = "_ei-4";
export var shipmentSummaryFact = "_ei-e";
export var shipmentSummaryGrid = "_ei-d";
export var shipmentSummaryMetadataRow = "_ei-f";
export var shipmentSummaryTags = "_ei-g";
export var shipmentWorkspace = "_ei-0";
export var shipmentWorkspaceContent = "_ei-6";
export var shipmentWorkspaceHeader = "_ei-1";